import { Row, Col } from "react-flexbox-grid";
import { Result, Button } from "antd";

export const Page404 = () => {
  return (
    <Row center="xs" middle="xs" style={{ minHeight: "100vh" }}>
      <Col
        md={12}
        data-aos="fade-zoom-in"
        data-aos-easing="ease-in-back"
        data-aos-delay="200"
        data-aos-offset="0"
      >
        <Result
          status="404"
          title="Página no encontrada"
          subTitle="Revisa la dirección a la que deseas acceder"
          extra={
            <Button type="primary" onClick={() => window.location.replace("/")}>
              Regresar a inicio
            </Button>
          }
        />
      </Col>
    </Row>
  );
};
